module.exports = __webpack_public_path__ + "img/C08TechAshokasVirtue_ua.9f837069.webp";